import { CSSProperties } from 'react';

export const heading: CSSProperties = { marginBottom: '25px' };

export const txWrapper: CSSProperties = {
  textAlign: 'center',
  marginTop: '15px',
};
